import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Type,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { EaDisplay } from '@app/components/pr-display';
import { PrFormService } from '@app/components/pr-form/pr-form.service';
import * as _ from 'lodash';
import { Thumbs } from 'swiper';

export class SimulationParameter {
  icon: string;
  label: any;
  value: any;
  suffix: string;
  tooltip: string;
  showOnlyIf?: (simulation: any) => boolean;

  constructor(
    icon: string,
    label: string,
    value: any,
    suffix: string,
    tooltip?: string,
    showOnlyIf?: (simulation: any) => boolean,
  ) {
    this.icon = icon;
    this.label = label;
    this.value = value;
    if (suffix) this.suffix = suffix;
    if (tooltip) this.tooltip = tooltip;
    if (showOnlyIf) this.showOnlyIf = showOnlyIf;
  }
}

export class SimulationParameters {
  label: any;
  parameters: SimulationParameter[];
  showContent?(simulation): boolean;
  showMap?(simulation): boolean;

  constructor(
    label: string,
    parameters: SimulationParameter[],
    showContent: () => true,
    showMap: () => false,
  ) {
    this.label = label;
    this.parameters = parameters;
    this.showContent = showContent;
    this.showMap = showMap;
  }
}

export class SimulationInformations {
  label: any;
  content: string;
  display: EaDisplay;

  constructor(
    label: string,
    content: string,
    display: EaDisplay = EaDisplay.warning,
  ) {
    this.label = label;
    this.content = content;
    this.display = display;
  }
}

@Component({
    selector: 'ea-simulation-parameters',
    templateUrl: './ea-simulation-parameters.component.html',
    styleUrls: ['./ea-simulation-parameters.component.scss'],
    standalone: false
})
export class EaSimulationParametersComponent implements OnInit {
  @Input() form: Type<any>;
  @Input() formOptions: any;
  @Input() simulation: any;
  @Input() groups: Array<SimulationParameters | SimulationInformations | any>;
  @Input() pdf: boolean = false;
  @Input() title: any = 'Paramètres de votre simulation';
  @Input() loading: boolean = false;
  @Input() openOnInit: boolean = false;
  @Output() loadingChange: EventEmitter<boolean> = new EventEmitter();

  @Output() onModify: EventEmitter<any> = new EventEmitter();
  @Output() onEdit: EventEmitter<any> = new EventEmitter();
  @Output() onDownload: EventEmitter<any> = new EventEmitter();

  constructor(
    public prFormService: PrFormService,
    public sanitizer: DomSanitizer,
  ) {}

  ngOnInit() {
    if (this.openOnInit == true) {
      this.triggerForm();
    }
  }

  triggerForm() {
    this.onModify.emit();
    this.prFormService.trigger(
      this.form,
      this.simulation.parameters,
      simulation => this.edit(simulation),
      this.formOptions,
    );
  }

  setLoading(loading: boolean) {
    this.loading = loading;
    this.loadingChange.emit(loading);
  }

  edit(simulation: any) {
    this.onEdit.emit(simulation);
  }

  value(parameter: SimulationParameter) {
    let value;
    try {
      value = parameter.value(this.simulation);
    } finally {
      if (value != undefined && value != null && parameter.suffix)
        value += ' ' + parameter.suffix;

      if (!value && value !== 0) value = 'N/C';

      return value;
    }
  }

  showOnlyIf(parameter: SimulationParameter) {
    return this.simulation && parameter.showOnlyIf
      ? parameter.showOnlyIf(this.simulation)
      : true;
  }

  /**
   * Résout une valeur qui peut être soit une constante, soit une fonction paresseuse à
   * appeler avec le contexte du composant.
   *
   * Ne pas la renommer avec le nom de la fonction JavaScript d'évaluation : cette méthode
   * n'évalue aucune chaîne, mais porter ce nom faisait remonter le composant à chaque recherche
   * lors des audits de sécurité (CASA 5.1.3), en donnant l'apparence d'une exécution dynamique
   * de code.
   */
  resolveValue(val) {
    return typeof val === 'function' ? val(this.simulation) : val;
  }
}
